import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import removePhraseFromClause from '../actions/helpers/removePhraseFromClause';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import isValidClause from '../utils/isValidClause';
import setClauseErrorText from '../actions/helpers/setClauseErrorText';
var styles = require('./PhrasePill.scss');
/*
Phrase pills are used in the 'includes these words' clauses for inbox rules.
A user enters text in the input and presses enter to commit the phrase and
create a phrase pill
*/
var PhrasePill = /** @class */ (function (_super) {
    tslib_1.__extends(PhrasePill, _super);
    function PhrasePill() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PhrasePill.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: styles.phrasePill },
            React.createElement("span", { className: styles.phrasePillText, title: this.props.phrase }, this.props.phrase),
            React.createElement(IconButton, { className: styles.phrasePillClose, iconProps: {
                    iconName: "Cancel" /* Cancel */,
                    styles: {
                        root: styles.cancelIcon,
                    },
                }, onClick: function () {
                    removePhraseFromClause(_this.props.clauseId, _this.props.phrase);
                    setClauseErrorText(_this.props.clauseId, isValidClause(_this.props.clauseId));
                } })));
    };
    PhrasePill = tslib_1.__decorate([
        observer
    ], PhrasePill);
    return PhrasePill;
}(React.Component));
export default PhrasePill;
//# sourceMappingURL=PhrasePill.js.map